import React from 'react';
import { formatCurrency } from '../gameData';

function BorrowDialog({ show, onConfirm, onClose, maxBorrowable }) {
  if (!show) return null;

  const handleBorrowMax = () => {
    onConfirm(maxBorrowable);
  };

  const handleBorrowStandard = () => {
    onConfirm(500);
  };

  return (
    <dialog open={show} className="borrow-dialog">
      <h3>💵 Borrow Money 💵</h3>
      <p>Current Debt Limit: {formatCurrency(5000)}</p>
      <div className="borrow-options">
        <button 
          onClick={handleBorrowMax}
          disabled={maxBorrowable === 0}
          className={maxBorrowable > 0 ? 'primary-button' : 'disabled-button'}
        >
          Borrow Max ({formatCurrency(maxBorrowable)})
        </button>
        
        <div className="borrow-standard">
          <p>Or borrow standard amount:</p>
          <button 
            onClick={handleBorrowStandard}
            disabled={maxBorrowable < 500}
            className={maxBorrowable >= 500 ? 'secondary-button' : 'disabled-button'}
          >
            Borrow {formatCurrency(500)}
          </button>
        </div>
      </div>
      <div className="dialog-buttons">
        <button onClick={onClose}>Cancel</button>
      </div>
    </dialog>
  );
}

export default BorrowDialog; 